import React, { useMemo, useCallback } from 'react';
import PropTypes from 'prop-types';
import { Input } from 'antd';

export const CustomCurrencyField = ({ value, onChange, disabledField }) => {
  const fieldValue = value ?? '';

  const getNumberValue = (numberText) => {
    let resultValue = '';
    for (let upperBound = numberText.length; upperBound > 0; upperBound -= 3) {
      const lowerBound = Math.max(upperBound - 3, 0);
      let slice = numberText.slice(lowerBound, upperBound);
      if (resultValue.length) slice += ',';
      resultValue = slice + resultValue;
    }
    return resultValue;
  };

  const getNumberWithDecimals = (intPart, decimalPart) => {
    const number = intPart || '0';
    const decimals = decimalPart.slice(0, 3);
    return `${number}.${decimals}`;
  };

  const formatInput = useCallback((inputValue) => {
    const textInput = inputValue ? String(inputValue) : '';
    const splitInput = textInput.replace(/[^\d.]/g, '').split('.');
    const intPart = getNumberValue(splitInput[0]);
    if (splitInput.length <= 1) return intPart;
    return getNumberWithDecimals(intPart, splitInput[1]);
  }, []);

  const maskInput = (e) => {
    e.target.value = formatInput(e.target.value);
  };

  const onChangeValue = (e) => {
    onChange(e.target.value);
  };

  const defaultValue = useMemo(() => formatInput(fieldValue), [fieldValue, formatInput]);

  return <Input onInput={maskInput} onChange={onChangeValue} defaultValue={defaultValue} disabled={disabledField} />;
};

CustomCurrencyField.propTypes = {
  field: PropTypes.shape({
    idInput: PropTypes.string,
    label: PropTypes.string,
  }),
  value: PropTypes.string,
  onChange: PropTypes.func,
  disabledField: PropTypes.bool,
};
